import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoHint = _resolveComponent("InfoHint")!
  const _component_b_field = _resolveComponent("b-field")!

  return (_openBlock(), _createBlock(_component_b_field, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label), 1),
      (_ctx.hintKey)
        ? (_openBlock(), _createBlock(_component_InfoHint, {
            key: 0,
            messageKey: _ctx.hintKey,
            class: "ml-1"
          }, null, 8, ["messageKey"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}